import type {ReactNode} from 'react';
import {TableCell, TableRow} from '@/shared/ui/table';

interface TableBodyStateProps {
  colSpan: number;
  loading?: boolean;
  loadingContent?: ReactNode;
  empty?: boolean;
  emptyContent?: ReactNode;
}

const TableBodyState = ({
  colSpan,
  loading = false,
  loadingContent,
  empty = false,
  emptyContent = 'No records found',
}: TableBodyStateProps) => {
  if (!loading && !empty) return null;

  return (
    <TableRow>
      <TableCell
        colSpan={colSpan}
        className={loading ? 'text-center py-12' : 'text-center py-8 text-muted-foreground'}
      >
        {loading ? loadingContent : emptyContent}
      </TableCell>
    </TableRow>
  );
};

export default TableBodyState;
